import { composeIO } from 'react-compose-io'
import { uploadPlanilhaCicloPedidoIO } from './UploadPlanilhaCicloPedido.IO'
import { UploadPlanilhaCicloPedidoView } from './UploadPlanilhaCicloPedido.View'

export const UploadPlanilhaCicloPedido = composeIO(UploadPlanilhaCicloPedidoView, uploadPlanilhaCicloPedidoIO)
